export default (props, vars) => !props?.['student']?.photo;
